import React from "react";
import { Modal, Text } from "@shopify/polaris";

const ConfirmationModal = ({ open, onClose, onConfirm, title, message }) => (
  <Modal
    open={open}
    onClose={onClose}
    title={title}
    primaryAction={{
      content: "Confirm",
      onAction: onConfirm,
    }}
    secondaryActions={[
      {
        content: "Cancel",
        onAction: onClose,
      },
    ]}
  >
    <Modal.Section>
      <Text variant="bodyLg">{message}</Text>
    </Modal.Section>
  </Modal>
);

export default ConfirmationModal;
